import React, { FC } from 'react';
import { OperatorPanelNoConnectorProps } from './OperatorPanelNoConnector';
import { ContentUnavailableCentralPart } from './ContentUnavailableCentralPart';
import { scale as initialScale } from '@components/frame';
import UnavailableContent from './UnavailableContent';
import { font as initialFont } from '@styles/fonts';

interface OperatorPanelConnectionOffProps extends OperatorPanelNoConnectorProps {}

const OperatorPanelConnectionOff: FC<OperatorPanelConnectionOffProps> = ({
  CC,
  machineName,
  isOperator,
  machineStatus,
  time,
  insetBottom,
  insetTop,
  scale = initialScale,
  font = initialFont,
}) => {
  return (
    <UnavailableContent {...{ CC, machineName, machineStatus, isOperator, insetBottom, insetTop, scale, font }}>
      <ContentUnavailableCentralPart
        {...{
          CC,
          iconConfig: { icon: 'machineConnectionOff', width: scale(300), height: scale(220), color: CC('Label/Light/Error') },
          title: 'Connection Switched Off',
          text: 'Switch the Machine Connection On to see your CNC machine on your phone, tablet and on the web.',
          time,
          scale,
          font,
        }}
      />
    </UnavailableContent>
  );
};

export default OperatorPanelConnectionOff;
